<mat-card>
  <app-card-header
    icono="notifications_active"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="!!dialogRef"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Form -->
      <mat-card-content
        [class.cardContentDialog]="dialogRef"
        [class.cardContentFullscreen]="!dialogRef && !subtitle"
        [class.cardContentFullscreenSubtitle]="!dialogRef && subtitle"
        class="card-content-crear"
        (scroll)="onScroll()"
      >
        <!-- Módulos y Agrupación -->
        <app-content-card
          title="Configuración de Alcance"
          icon="settings"
          color="purple"
        >
          <section class="inputs-group">
            <!-- Módulos -->
            @if (!params.tipoEntidad) {
              <ng-select
                style="width: 100%"
                formControlName="tipoEntidad"
                placeholder="Módulo"
                [items]="tiposEntidades"
                bindLabel="label"
                bindValue="value"
                appendTo="body"
                notFoundText="Sin resultados"
              ></ng-select>
            }

            <!-- Agrupación -->
            @if (!params.tipoEntidad) {
              <app-section-title
                title="Agrupación de {{ form?.value?.tipoEntidad }}"
                icon="group_work"
                color="purple"
              ></app-section-title>

              <ng-select
                style="width: 100%"
                formControlName="agrupacion"
                placeholder="Tipo de Agrupación"
                [items]="tiposAgrupaciones"
                bindLabel="label"
                bindValue="value"
                appendTo="body"
                notFoundText="Sin resultados"
              ></ng-select>
            }

            <!-- Banner Global -->
            @if (form?.value?.agrupacion === 'Global') {
              <app-info-banner
                title="Alcance Global"
                message="Se notificará de todos los dispositivos del cliente"
                icon="public"
                color="blue"
                [closable]="false"
              ></app-info-banner>
            }

            <!-- Selector de Grupo -->
            @if (!params.idGrupo && form?.value?.agrupacion === 'Grupo') {
              <app-info-banner
                title="Alcance de Grupo"
                message="Se notificará de todos los dispositivos del grupo seleccionado"
                icon="folder"
                color="orange"
                [closable]="false"
              ></app-info-banner>

              <ng-select
                style="width: 100%"
                formControlName="idGrupo"
                placeholder="Grupo"
                [items]="grupos"
                bindLabel="nombre"
                bindValue="_id"
                appendTo="body"
                notFoundText="Sin resultados"
              ></ng-select>
            }

            <!-- Selector de Activo -->
            @if (
              !params.idEntidad &&
              form?.value?.agrupacion === 'Entidad' &&
              form?.value?.tipoEntidad === 'Activo'
            ) {
              <app-info-banner
                title="Alcance Individual"
                message="Se notificará solo del activo seleccionado"
                icon="devices"
                color="green"
                [closable]="false"
              ></app-info-banner>

              <ng-select
                [items]="searchActivos$ | async"
                [minTermLength]="3"
                bindLabel="identificacion"
                bindValue="_id"
                formControlName="idEntidad"
                placeholder="Activo"
                loadingText="Cargando..."
                typeToSearchText="Buscar..."
                notFoundText="No se encontraron resultados"
                [loading]="loadingActivos"
                [typeahead]="searchTermActivos$"
                (search)="searchActivos($event.term)"
                appendTo="body"
              ></ng-select>
            }

            <!-- Selector de Vehículo -->
            @if (
              !params.idEntidad &&
              form?.value?.agrupacion === 'Entidad' &&
              form?.value?.tipoEntidad === 'Vehiculo'
            ) {
              <app-info-banner
                title="Alcance Individual"
                message="Se notificará solo del vehículo seleccionado"
                icon="directions_car"
                color="green"
                [closable]="false"
              ></app-info-banner>

              <ng-select
                [items]="searchVehiculos$ | async"
                [minTermLength]="3"
                bindLabel="identificacion"
                bindValue="_id"
                formControlName="idEntidad"
                placeholder="Vehículo"
                loadingText="Cargando..."
                typeToSearchText="Buscar..."
                notFoundText="No se encontraron resultados"
                [loading]="loadingVehiculos"
                [typeahead]="searchTermVehiculos$"
                (search)="searchVehiculos($event.term)"
                appendTo="body"
              ></ng-select>
            }

            <!-- Selector de Alarma -->
            @if (
              !params.idEntidad &&
              form?.value?.agrupacion === 'Entidad' &&
              form?.value?.tipoEntidad === 'Alarma'
            ) {
              <app-info-banner
                title="Alcance Individual"
                message="Se notificará solo de la alarma seleccionada"
                icon="security"
                color="green"
                [closable]="false"
              ></app-info-banner>

              <ng-select
                [items]="searchAlarmas$ | async"
                [minTermLength]="3"
                bindLabel="nombre"
                bindValue="_id"
                formControlName="idEntidad"
                placeholder="Alarma"
                loadingText="Cargando..."
                typeToSearchText="Buscar..."
                notFoundText="No se encontraron resultados"
                [loading]="loadingAlarmas"
                [typeahead]="searchTermAlarmas$"
                (search)="searchAlarmas($event.term)"
                appendTo="body"
              ></ng-select>
            }

            <!-- Selector de Luminaria -->
            @if (
              !params.idEntidad &&
              form?.value?.agrupacion === 'Entidad' &&
              form?.value?.tipoEntidad === 'Luminaria'
            ) {
              <app-info-banner
                title="Alcance Individual"
                message="Se notificará solo de la luminaria seleccionada"
                icon="lightbulb"
                color="green"
                [closable]="false"
              ></app-info-banner>

              <ng-select
                [items]="searchLuminarias$ | async"
                [minTermLength]="3"
                bindLabel="identificacion"
                bindValue="_id"
                formControlName="idEntidad"
                placeholder="Luminaria"
                loadingText="Cargando..."
                typeToSearchText="Buscar..."
                notFoundText="No se encontraron resultados"
                [loading]="loadingLuminarias"
                [typeahead]="searchTermLuminarias$"
                (search)="searchLuminarias($event.term)"
                appendTo="body"
              ></ng-select>
            }
          </section>
        </app-content-card>

        <!-- Condiciones de Generación -->
        <app-content-card
          title="Condición de Generación de Evento"
          icon="rule"
          color="blue"
        >
          <section class="inputs-group">
            <!-- Selector de tipo de condición -->
            @if (!params.tipoCondicion) {
              <ng-select
                [formGroup]="form"
                style="width: 100%"
                formControlName="tipoCondicion"
                placeholder="Tipo de Condición"
                [items]="tiposCondicionDeEntidad"
                bindLabel="valor"
                bindValue="valor"
                appendTo="body"
                notFoundText="Sin resultados"
              ></ng-select>
            }

            @switch (tipoEntidad) {
              <!-- Configuración de Activo y vehiculo -->
              @case (
                tipoEntidad === 'Activo' || tipoEntidad === 'Vehiculo'
                  ? tipoEntidad
                  : null
              ) {
                <!-- Condicion Ubicacion -->
                @if (tipoCondicion === 'Ubicación') {
                  <div [formGroup]="configUbicacionActivo">
                    <!-- Ubicacion -->
                    <ng-select
                      [items]="ubicacions"
                      formControlName="idUbicacion"
                      [multiple]="false"
                      placeholder="Ubicación"
                      style="width: 100%"
                      bindLabel="identificacion"
                      bindValue="_id"
                      notFoundText="No se encontraron resultados"
                    ></ng-select>

                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                        padding-left: 8px;
                      "
                    >
                      <!-- Check dentro -->
                      <mat-checkbox color="primary" formControlName="dentro">
                        Notificar si entra
                      </mat-checkbox>
                      <!-- Check fuera -->
                      <mat-checkbox color="primary" formControlName="fuera">
                        Notificar si sale
                      </mat-checkbox>
                    </div>
                  </div>
                }

                <!-- Condicion Velocidad -->
                @if (tipoCondicion === 'Velocidad') {
                  <div [formGroup]="configVelocidadActivo">
                    <mat-form-field style="width: 100%">
                      <mat-label>Velocidad Superior a</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="superior a"
                        required
                      />
                      <mat-icon matPrefix>speed</mat-icon>
                      <span matSuffix style="padding-right: 5px">Km/h</span>
                    </mat-form-field>
                    <mat-form-field style="width: 100%; margin-top: 14px">
                      <mat-label>Tiempo mínimo a esa velocidad</mat-label>
                      <input
                        matInput
                        type="number"
                        min="0"
                        formControlName="tiempoMinimo"
                      />
                      <mat-icon matPrefix>timer</mat-icon>
                      <span matSuffix style="padding-right: 5px">seg</span>
                      <mat-hint>
                        La velocidad debe sostenerse este tiempo seguido para
                        generar el evento. Vacío = dispara al instante.
                      </mat-hint>
                    </mat-form-field>
                  </div>
                }

                <!-- Condicion Exceso de velocidad por límite de la calle -->
                @if (tipoCondicion === 'Exceso de velocidad por calle') {
                  <div [formGroup]="configExcesoVelocidadCalleActivo">
                    <p style="margin: 0 0 8px; opacity: 0.7; font-size: 12px">
                      El límite de velocidad de la calle lo resuelve el sistema
                      en base a la información disponible. El evento salta
                      cuando se supera ese límite.
                    </p>
                    <mat-form-field style="width: 100%">
                      <mat-label>Tolerancia (%)</mat-label>
                      <input
                        matInput
                        type="number"
                        step="1"
                        min="0"
                        formControlName="tolerancia"
                        placeholder="10"
                      />
                      <mat-icon matPrefix>percent</mat-icon>
                      <span matSuffix style="padding-right: 5px">%</span>
                      <mat-hint>
                        Ej.: 10 = permite hasta +10% sobre el límite de la calle
                        antes de generar el evento (60 km/h → salta a 66 km/h)
                      </mat-hint>
                    </mat-form-field>
                    <mat-form-field style="width: 100%; margin-top: 14px">
                      <mat-label>Límite de respaldo</mat-label>
                      <input
                        matInput
                        type="number"
                        min="0"
                        formControlName="umbralFallback"
                      />
                      <mat-icon matPrefix>speed</mat-icon>
                      <span matSuffix style="padding-right: 5px">Km/h</span>
                      <mat-hint>
                        En algunas calles el sistema no tiene el límite. En esos
                        casos compara contra esta velocidad fija. Si lo dejás
                        vacío, en calles sin dato no se genera el evento.
                      </mat-hint>
                    </mat-form-field>
                    <mat-form-field style="width: 100%; margin-top: 14px">
                      <mat-label>Tiempo mínimo a esa velocidad</mat-label>
                      <input
                        matInput
                        type="number"
                        min="0"
                        formControlName="tiempoMinimo"
                      />
                      <mat-icon matPrefix>timer</mat-icon>
                      <span matSuffix style="padding-right: 5px">seg</span>
                      <mat-hint>
                        El exceso debe sostenerse este tiempo seguido para
                        generar el evento. Vacío = dispara al instante.
                      </mat-hint>
                    </mat-form-field>
                  </div>
                }

                <!-- Condicion Detenido -->
                @if (tipoCondicion === 'Detenido') {
                  <div [formGroup]="configDetenidoActivo">
                    <mat-form-field style="width: 100%">
                      <mat-label>Detenido Más de</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="mas de"
                        required
                      />
                      <mat-icon matPrefix>schedule</mat-icon>
                      <span matSuffix style="padding-right: 5px">Minutos</span>
                    </mat-form-field>
                  </div>
                }

                <!-- Condicion Recorridos -->
                @if (tipoCondicion === 'Recorridos') {
                  <div [formGroup]="configRecorridosActivo">
                    <mat-form-field style="width: 100%">
                      <mat-label>Distancia</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="distancia"
                      />
                      <mat-icon matPrefix>straighten</mat-icon>
                      <span matSuffix>metros</span>
                    </mat-form-field>

                    <div
                      style="display: flex; flex-direction: column; gap: 8px"
                    >
                      <!-- Check dentro -->
                      <mat-checkbox color="primary" formControlName="dentro">
                        Notificar si entra
                      </mat-checkbox>
                      <!-- Check fuera -->
                      <mat-checkbox color="primary" formControlName="fuera">
                        Notificar si sale
                      </mat-checkbox>
                    </div>
                  </div>
                }
                <!-- Condicion Divergencia GPS -->
                @if (tipoCondicion === 'Divergencia GPS') {
                  <div
                    style="
                      display: flex;
                      align-content: center;
                      justify-content: flex-start;
                      align-items: center;
                      gap: 5px;
                    "
                  >
                    <!-- Checkbox principal -->
                    <mat-checkbox
                      color="primary"
                      [formControl]="configDivergenciaGPSActivo"
                      style="font-weight: 500"
                    >
                      Detectar divergencia GPS alta consecutiva
                    </mat-checkbox>

                    <!-- Hint informativo -->
                    <app-hint
                      icon="info"
                      color="blue"
                      message="Se detecta cuando un vehículo presenta divergencia GPS alta (>20m) durante 3 o más reportes consecutivos."
                    ></app-hint>
                  </div>
                }
              }

              <!-- Configuración de Luminaria -->
              @case (tipoEntidad === 'Luminaria' ? tipoEntidad : null) {
                <!-- Condición potencia -->
                @if (tipoCondicion === 'Potencia') {
                  <div>
                    <app-hint
                      icon="lightbulb"
                      color="yellow"
                      message="Los eventos de potencia solo se comprueban con el relé activado"
                      style="margin-bottom: 16px"
                    ></app-hint>

                    <div [formGroup]="configPotenciaLuminaria">
                      <!-- superior a -->
                      <mat-form-field style="width: 100%">
                        <mat-label>
                          Porcentaje superior al valor nominal
                        </mat-label>
                        <input
                          matInput
                          type="number"
                          formControlName="superior a"
                          required
                        />
                        <mat-icon matPrefix>trending_up</mat-icon>
                        <span matSuffix>%</span>
                      </mat-form-field>
                      <!-- inferior a -->
                      <mat-form-field style="width: 100%">
                        <mat-label>
                          Porcentaje inferior al valor nominal
                        </mat-label>
                        <input
                          matInput
                          type="number"
                          formControlName="inferior a"
                          required
                        />
                        <mat-icon matPrefix>trending_down</mat-icon>
                        <span matSuffix>%</span>
                      </mat-form-field>
                    </div>
                  </div>
                }

                <!-- Condición voltaje -->
                @if (tipoCondicion === 'Voltaje') {
                  <div [formGroup]="configVoltajeLuminaria">
                    <div style="display: flex; gap: 16px">
                      <!-- superior a -->
                      <mat-form-field style="flex: 1">
                        <mat-label>Voltaje Superior a</mat-label>
                        <input
                          matInput
                          type="number"
                          formControlName="superior a"
                          required
                        />
                        <mat-icon matPrefix>trending_up</mat-icon>
                        <span matSuffix>V</span>
                      </mat-form-field>
                      <!-- inferior a -->
                      <mat-form-field style="flex: 1">
                        <mat-label>Voltaje Inferior a</mat-label>
                        <input
                          matInput
                          type="number"
                          formControlName="inferior a"
                          required
                        />
                        <mat-icon matPrefix>trending_down</mat-icon>
                        <span matSuffix>V</span>
                      </mat-form-field>
                    </div>
                  </div>
                }
              }
              @case ('Alarma') {
                <div [formGroup]="condicionAlarma">
                  <!-- LLega evento -->
                  @if (tipoCondicion === 'Llega evento') {
                    <ng-select
                      formControlName="tipoCodigo"
                      [items]="opcionesDeEventoAlarma"
                      placeholder="Opción de Código"
                      (change)="changeTipoCodigo()"
                    ></ng-select>
                    @if (condicionAlarma.value.tipoCodigo === 'Código Único') {
                      <ng-select
                        formControlName="llega evento"
                        [items]="codigosAlarma"
                        bindValue="codigo"
                        placeholder="Código"
                        [notFoundText]="'No hay Códigos'"
                        style="width: 100%"
                        multiple="false"
                        [searchFn]="searchCodigo"
                        searchable="true"
                        (change)="setCodigo($event)"
                      >
                        <ng-template ng-label-tmp let-item="item">
                          {{ item.codigo }} - {{ item.descripcion }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          {{ item.codigo }} - {{ item.descripcion }}
                        </ng-template>
                      </ng-select>
                    }
                  }
                  <!-- No llega evento -->
                  @if (tipoCondicion === 'No llega evento') {
                    <ng-select
                      formControlName="tipoCodigo"
                      [items]="opcionesDeEventoAlarma"
                      placeholder="Opción de Código"
                      (change)="changeTipoCodigo()"
                    ></ng-select>
                    @if (condicionAlarma.value.tipoCodigo === 'Código Único') {
                      <ng-select
                        formControlName="no llega evento"
                        [items]="codigosAlarma"
                        bindValue="codigo"
                        placeholder="Código"
                        [notFoundText]="'No hay Códigos'"
                        style="width: 100%"
                        multiple="false"
                        [searchFn]="searchCodigo"
                        searchable="true"
                        (change)="setCodigo($event)"
                      >
                        <ng-template ng-label-tmp let-item="item">
                          {{ item.codigo }} - {{ item.descripcion }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          {{ item.codigo }} - {{ item.descripcion }}
                        </ng-template>
                      </ng-select>
                    }
                  }
                  @if (mostrarZona) {
                    <div class="row-flex-start" [formGroup]="configZona">
                      <!-- Parti -->
                      <mat-form-field style="width: 49%; margin-right: 2%">
                        <mat-label>Partición</mat-label>
                        <input
                          matInput
                          formControlName="particion"
                          type="number"
                        />
                      </mat-form-field>
                      <!-- Zona -->
                      <mat-form-field style="width: 49%">
                        <mat-label>Zona</mat-label>
                        <input matInput formControlName="zona" type="number" />
                      </mat-form-field>
                    </div>
                  }
                </div>
              }
            }
          </section>
        </app-content-card>

        <!-- Información del Evento -->
        <app-content-card
          title="Información del Evento"
          icon="event"
          color="green"
        >
          <section class="inputs-group">
            <!-- Categoria -->
            <div style="display: flex; width: 100%; gap: 8px">
              @if (!params.categoriaEvento) {
                <ng-select
                  [items]="categoriasEvento"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idCategoriaEvento"
                  placeholder="Categoría"
                  [notFoundText]="'No hay categorías creadas'"
                  style="width: 100%"
                  multiple="false"
                  searchable="true"
                  appendTo="body"
                  required
                ></ng-select>
              }
              @if (
                helper.tienePermiso('Administración - Crear categorias eventos')
              ) {
                <app-button
                  matType="mat-fab"
                  color="primary"
                  icon="add"
                  (click)="crearCategoria()"
                ></app-button>
              }
            </div>

            <!-- Tipo de Evento -->
            @if (!params.listadoCategoria && form?.value?.tipoEntidad) {
              <app-listado-categoria-selector
                [idCliente]="null"
                [categoria]="categoriaTipoEvento"
                [categorias]="
                  categoriaTipoEvento ? [categoriaTipoEvento] : null
                "
                placeholder="Tipo de Evento"
                notFoundText="No hay tipo de eventos creados"
                [multiple]="false"
                [showCrearBtn]="true"
                [initialNames]="listadoCategoriaInitialNames"
                (listadoCategoriaChange)="onListadoCategoriaChange($event)"
                style="width: 100%"
              ></app-listado-categoria-selector>
            }
          </section>
        </app-content-card>

        <!-- Frecuencia -->
        @if (muestraFrecuencia) {
          <app-content-card title="Frecuencia" icon="schedule" color="orange">
            <section class="inputs-group">
              <!-- Tipo de frecuencias -->
              <ng-select
                style="width: 100%"
                formControlName="frecuencia"
                placeholder="Frecuencia"
                [items]="frecuenciasOpciones"
                bindLabel="label"
                bindValue="value"
                appendTo="body"
                notFoundText="Sin resultados"
              ></ng-select>
              <small class="config-evento-cronograma-hint">
                @if (form?.value?.frecuencia === 'Unica') {
                  <span>Se generará el evento una sola vez</span>
                }
                @if (form?.value?.frecuencia === 'Continua') {
                  <span>
                    Se generarán eventos de manera continua por tiempo
                    indeterminado
                  </span>
                }
                @if (form?.value?.frecuencia === 'Unica en un periodo') {
                  <span>
                    Se generará el evento una sola vez dentro del período de
                    tiempo seleccionado
                  </span>
                }
                @if (form?.value?.frecuencia === 'Continua en un periodo') {
                  <span>
                    Se generarán eventos de manera continua dentro del período
                    de tiempo seleccionado
                  </span>
                }
                @if (form?.value?.frecuencia === 'Cronograma') {
                  <span>
                    Se generarán eventos solo los días selecionados en el rango
                    horario establecido
                  </span>
                }
              </small>

              <!-- Date range -->
              @if (
                form?.value?.frecuencia === 'Unica en un periodo' ||
                form?.value?.frecuencia === 'Continua en un periodo'
              ) {
                <app-date-range-selector
                  [(dateRange)]="range"
                  [maxDate]="null"
                  [placeholder]="'Período de tiempo'"
                ></app-date-range-selector>
              }

              <!-- Checkbox generar si no se cumple -->
              @if (
                admiteGenerarSiNoSeCumple &&
                form?.value?.frecuencia === 'Unica en un periodo'
              ) {
                <mat-checkbox
                  color="primary"
                  formControlName="generarSiNoSeCumple"
                >
                  Generar evento si no se cumple la condición en el período de
                  tiempo
                </mat-checkbox>
              }

              <!-- Cronograma -->
              @if (form?.value?.frecuencia === 'Cronograma') {
                <div class="config-evento-cronograma">
                  <app-dias-semana-selector
                    formControlName="dias"
                  ></app-dias-semana-selector>
                  <!-- Label siempre arriba: el time-picker escribe el valor en
                       el input nativo y el form-field no lo detecta. -->
                  <div class="config-evento-cronograma-horas">
                    <app-time-picker
                      formControlName="horaInicio"
                      label="Desde"
                      placeholder=""
                      appearance="fill"
                      subscriptSizing="dynamic"
                      floatLabel="always"
                    ></app-time-picker>
                    <app-time-picker
                      formControlName="horaFin"
                      label="Hasta"
                      placeholder=""
                      appearance="fill"
                      subscriptSizing="dynamic"
                      floatLabel="always"
                    ></app-time-picker>
                  </div>
                  @if (!cronogramaValido) {
                    <span class="config-evento-cronograma-error">
                      Elegí al menos un día y un horario con "Desde" distinto de
                      "Hasta".
                    </span>
                  } @else {
                    <span class="config-evento-cronograma-hint">
                      Si "Hasta" es anterior a "Desde", el horario termina al
                      día siguiente.
                    </span>
                  }
                </div>
              }
            </section>
          </app-content-card>
        }

        <!-- Atención y Notificación -->
        <app-content-card
          title="Atención y Notificación"
          icon="notifications"
          color="red"
        >
          <section class="inputs-group">
            <!-- Requiere atencion -->
            <div
              style="
                display: flex;
                align-content: center;
                justify-content: flex-start;
                align-items: center;
                gap: 5px;
              "
            >
              <mat-checkbox color="primary" formControlName="atender">
                Requiere Atención
              </mat-checkbox>
              <app-hint
                message="Si no se activa el evento pasará directamente al historial"
                theme="info"
              ></app-hint>
            </div>

            <!-- Notificacion Push -->
            <div
              style="
                display: flex;
                align-content: center;
                justify-content: flex-start;
                align-items: center;
                gap: 5px;
              "
            >
              <mat-checkbox color="primary" formControlName="notificar">
                Notificación Push
              </mat-checkbox>
              <app-hint
                message="Si no se activa solo se genera el evento"
                theme="info"
              ></app-hint>
            </div>

            @if (form?.value?.notificar) {
              <!-- USUARIOS -->
              <ng-select
                [items]="usuarios"
                placeholder="Usuarios"
                loadingText="Cargando..."
                typeToSearchText="Buscar..."
                notFoundText="No se encontraron resultados"
                formControlName="idsUsuarios"
                [multiple]="true"
                [searchFn]="searchUsuario"
                [closeOnSelect]="false"
                [bindValue]="'_id'"
              >
                <ng-template ng-label-tmp let-item="item">
                  <span>{{ item.usuario }}</span>
                </ng-template>
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-item$="item$"
                  let-index="index"
                >
                  <div style="padding-bottom: 5px">
                    <span>{{ item.usuario }}</span>
                    <span style="font-size: 0.7em">
                      ({{ item.datosPersonales?.telefono }})
                    </span>
                  </div>
                </ng-template>
              </ng-select>
            }
          </section>
        </app-content-card>
      </mat-card-content>
      <mat-divider></mat-divider>
      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="volver()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || !cronogramaValido || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  }
</mat-card>
